import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

const AppProviders = lazy(() => import('@app/components/AppProviders'))
const UploadFooter = lazy(() => import('.'))

class UploadFooterComponent extends ReactWebComponent {
  override render() {
    return (
      <AppProviders>
        <UploadFooter />
      </AppProviders>
    )
  }
}

customElements.define('upload-footer', UploadFooterComponent)
